







































































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import * as api from '@/api';
import { TrainClassDto } from '@/api/models';
import moment from 'moment';
import { isNull } from 'lodash';
import SessionModule from '@/store/modules/session';
import { Dialog } from 'vant';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
@Component({ components: { confirmFeedback } })
export default class ClassInfoIndex extends Vue {
  @Prop() currentClass: any;

  @Watch('currentClass', { deep: true, immediate: true })
  async onCurrentClassChangeAsync(val: any) {
    this.classItem = val;
    const res = await api.TrainRecords.checkIsSignin_POST({ ids: [val.id] });
    if (res.data.includes(val.id)) {
      this.disabled = true;
      this.state = '已报到';
    }
  }

  disabled: any = false;
  state: string = '确认报到';
  classItem: any = {
    id: '',
    opreateType: '',
    classType: '',
    className: '',
    deptName: '',
    address: '',
    trainType: '',
    days: 0,
    startClassDate: '',
    endClassDate: '',
    content: '',
    runClassType: '',
    objectScope: '',
    number: 0,
    trainingSchedulings: [],
    schedulingAttachmentKey: '',
  };
  loading: boolean = false;
  finished: boolean = false;
  feedbackShow: boolean = false;
  feedbackType: string = '';
  successStatu: boolean = false;
  errorMsg: string = '';
  //报到点击事件
  async onSignUp() {
    try {
      let that = this;
      that.feedbackShow = true;
      const { data, success, message } = await api.TrainRecords.classSignin_POST({
        classId: that.classItem.id,
        classType: that.classItem.classType,
      });
      if (success) {
        that.successStatu = true;
        setTimeout(() => {
          that.$emit('classEditSuccess');
          this.$router.push({
            name: 'trainingDetail',
            params: {
              trainStatus: '培训中',
              title: '培训中',
              classItem: JSON.stringify(that.classItem),
            },
          });
        }, 1000);
      } else {
        that.successStatu = false;
        that.errorMsg = message;
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }

    this.feedbackType = '报到';
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
}
